import React, { FC, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Form from "./Form";
import AvatarDisplay from "./AvatarDisplay";
import ColourBorder from "../General-UI/ColourBorder";
import Modal from "../HOCS/Modal";
import { selectCurrentUserAttributes } from "slices/authSlice";
import {
  selectChangePicError,
  setChangePicError,
  getPicType,
  resetCreatePicture,
  getConfirmPicAction,
  doConfirmPicAction,
} from "slices/createPictureSlice";
import FullLogoSmall from "graphics/Branding/FullLogoSmall";
import history from "constants/history";
import { RouteComponentProps } from "@reach/router";

const CreatePicture: FC<RouteComponentProps> = () => {
  const dispatch = useDispatch();
  const { avatar_key } = useSelector(selectCurrentUserAttributes);
  const changePicError = useSelector(selectChangePicError);

  useEffect(() => {
    dispatch(getPicType());
    window.efs_debug && window.log("Getting pic type");
  }, [dispatch, avatar_key]);

  useEffect(() => {
    return () => {
      dispatch(resetCreatePicture());
    };
  }, [dispatch]);

  return (
    <div className="signInComponent">
      {changePicError ? (
        <Modal
          onDismiss={() => dispatch(setChangePicError(null))}
          lightBackDrop={false}
          growth={false}
          header={
            <div>{changePicError ? "Unable to use this picture" : null}</div>
          }
          content={<div>{changePicError ? changePicError : null}</div>}
          actions={null}
          noBackDropClick={false}
        ></Modal>
      ) : null}

      <ColourBorder />
      <div className="whiteContainer grey-background">
        <div
          className="logoCreatePic"
          onClick={() => {
            if (getConfirmPicAction()) doConfirmPicAction();
            else history.push("/");
          }}
        >
          <FullLogoSmall />
        </div>
        <div className="row nice-centre-row flex-column-reverse flex-lg-row">
          <div className="col-lg-6 col-sm-12">
            <Form />
          </div>
          <div className="col-lg-6 col-sm-12 text-center d-flex align-items-center justify-content-center">
            <AvatarDisplay />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreatePicture;
